import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  port: 3000,
  defaults: {
    apis: {
      examplesLanguage: "shell", // Default language for code examples
      disablePlayground: true, // Disable the interactive API playground
      disableSidecar: true,
      showVersionSelect: "if-available", // Control version selector visibility
      expandAllTags: false, // Control initial expanded state of tag categories
    },
  },
  //MARK: Theme
  theme: {
    light: {
      background: "#FFFFFF",
      foreground: "#111827",
      muted: "#F3F4F6",
      mutedForeground: "#6B7280",
      card: "#FFFFFF",
      cardForeground: "#111827",
      border: "#E5E7EB",
      input: "#E5E7EB",
      primary: "#057E6F",
      primaryForeground: "#FFFFFF",
      secondary: "#9333EA",
      secondaryForeground: "#FFFFFF",
      accent: "#057E6F",
      accentForeground: "#FFFFFF",
      destructive: "#DC2626",
      destructiveForeground: "#FFFFFF",
      ring: "#057E6F",
    },
    dark: {
      background: "#0B0B0E",
      foreground: "#FFFFFF",
      muted: "#1A1A1E",
      mutedForeground: "#9CA3AF",
      popover: "#111113",
      popoverForeground: "#E5E7EB",
      card: "#121214",
      cardForeground: "#E5E7EB",
      border: "#2D2D33",
      input: "#2D2D33",
      primary: "#057E6F",
      primaryForeground: "#FFFFFF",
      secondary: "#057E6F",
      secondaryForeground: "#FFFFFF",
      accent: "#057E6F",
      accentForeground: "#FFFFFF",
      destructive: "#EF4444",
      destructiveForeground: "#FFFFFF",
      ring: "#057E6F",
      radius: "0.5rem",
    },
  },
  //MARK: Auth
  protectedRoutes: {
    // "/api/pet": ({ auth, context }) => {
    //   return auth.isAuthenticated;
    // },
    // "/api/rickandmorty": ({ auth, context }) => {
    //   return auth.isAuthenticated;
    // },
  },
  // authentication: {
  //   type: "auth0",
  //   domain: "dev-1qepyfu3qbz5hevq.jp.auth0.com",
  //   clientId: "jjXKeJ2KLMiGOfr2LWKLIYWjW7Gq0NVo",
  //   audience: "http://localhost:3000/api",
  //   scopes: ["openid", "profile", "email", "read:api", "write:api"],
  // },
  // //MARK: Plugins
  // plugins: [
  //   createApiIdentityPlugin({
  //     getIdentities: async (context) => [
  //       {
  //         id: "AuthApiKey",
  //         label: "AuthApiKey",
  //         authorizeRequest: (request) => {
  //           // We get the access token from the
  //           // authentication provider (Auth0) and add it to the request headers
  //           const token = context.authentication?.getAccessToken();
  //           if (token) {
  //             request.headers.set("Authorization", `Bearer ${token}`);
  //           }
  //           return request;
  //         },
  //       },
  //     ],
  //   }),
  // ],
  //MARK: Sites
  site: {
    showPoweredBy: false,
    title: "NexQR Docs",
    logo: {
      src: { light: "/ic_logo_light.png", dark: "/ic_logo_dark.png" },
      alt: "Zudoku",
      width: "130px",
    },
    // banner: {
    //   message: "Welcome to our beta documentation!",
    //   color: "info", // "note" | "tip" | "info" | "caution" | "danger" or custom
    //   dismissible: true
    // },
    footer: {
      position: "center",
      copyright: `© ${new Date().getFullYear()} NexQR. All rights reserved.`,
      logo: {
        src: {
          light: "/ic_logo_light.png",
          dark: "/ic_logo_dark.png",
        },
        alt: "Company Logo",
        width: "120px", // optional width
      },
    },
  },
  //MARK: Metadata
  metadata: {
    title: "Nexdots",
    description: "This is an example description for the website.",
    logo: "https://media.nexdots.com/wml-cinema-staging/Logo%20-%20icon%20only.png",
    favicon:
      "https://media.nexdots.com/wml-cinema-staging/Logo%20-%20icon%20only.png",
    generator: "Website Generator 1.0",
    applicationName: "Example App",
    referrer: "no-referrer",
    keywords: ["example", "website", "metadata", "SEO"],
    authors: ["Nexdots", "Nexdots"],
    creator: "Nexdots",
    publisher: "Nexdots",
  },
  //MARK: Routes
  navigation: [
    {
      type: "doc",
      file: "landing",
      path: "/",
      display: "hide",
    },
    {
      type: "category",
      label: "Guides",
      icon: "book",
      items: [
        {
          type: "doc",
          label: "General",
          icon: "cog",
          file: "/guides/general",
        },
        {
          type: "doc",
          label: "Authentication",
          icon: "lock",
          file: "/guides/auth/authentication",
        },
        {
          type: "doc",
          label: "Cinemas",
          icon: "clapperboard",
          file: "/guides/cinema/cinemas",
        },
        {
          type: "doc",
          label: "Movies",
          icon: "film",
          file: "/guides/movie/movies",
        },
        {
          type: "doc",
          label: "Orders",
          icon: "notepad-text",
          file: "/guides/orders/channel-orders",
        },
        {
          type: "doc",
          label: "Tickets",
          icon: "ticket",
          file: "/guides/ticket/channel-tickets",
        },
      ],
    },
    {
      type: "link",
      to: "/api/docs",
      label: "API Reference",
    },
  ],
  //MARK: APIs
  apis: [
    {
      type: "file",
      input: "./apis/api.json",
      path: "/api/docs",
      categories: [
        { label: "General", tags: ["Operational"] },
        { label: "Movies & Cinemas", tags: ["Movies", "Cinemas", "Sessions"] },
        { label: "Orders", tags: ["Orders"] },
      ],
    },
  ],
};

export default config;
